import { useEffect } from "react";
import { BsBank, BsCalendarDate } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getEmployeesStatistics,
  getEmployeesStatisticsReport,
} from "../../store/EmployeesSlice";
import { MdOutlinePublic } from "react-icons/md";
import { RiContractLine, RiGitRepositoryPrivateLine } from "react-icons/ri";
import { LiaFileContractSolid } from "react-icons/lia";
import Statistics from "../../components/layouts/home/Statistics";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FaFileAlt } from "react-icons/fa";
import VoiceMessage from "../../components/VoiceMessage";
const EmployeeStatistics = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const {
    EmployeesStatisticsArray,
    EmployeesStatisticsReportArray,
  } = useSelector((state) => state.EmployeesSlice);

  useEffect(() => {
    dispatch(getEmployeesStatistics(id));
  }, [dispatch, id]);
  useEffect(() => {
    const data = {
      id,
    };
    dispatch(getEmployeesStatisticsReport(data));
  }, [dispatch, id]);
  return (
    <div className="Tabel_container">
      <div className=" grid justify-content-evenly  ">
        <div className="col-12 md:col-6 lg:col-4       ">
          <div className="cardHero">
            <div className="circle">
              <BsBank />
            </div>
            <h5>جميع الطلبات</h5>
            <h2> {EmployeesStatisticsArray?.total_orders}</h2>
          </div>
        </div>
        <div className="col-12 md:col-6 lg:col-4      ">
          <div className="cardHero cardHero2">
            <div className="circle">
              <BsCalendarDate />
            </div>
            <h5> عدد المواعيد والاستشارات</h5>
            <h2>{EmployeesStatisticsArray?.appointment_consultations_count}</h2>
          </div>
        </div>
        <div className="col-12 md:col-6 lg:col-4      ">
          <div className="cardHero cardHero3">
            <div className="circle">
              <RiContractLine />
            </div>
            <h5> عدد العقود</h5>
            <h2> {EmployeesStatisticsArray?.contracts_count}</h2>
          </div>
        </div>
        <div className="col-12 md:col-6 lg:col-4    ">
          <div className="cardHero cardHero1">
            <div className="circle">
              <MdOutlinePublic />
            </div>
            <h5> عدد الاستشارات الاقتصادية </h5>
            <h2> {EmployeesStatisticsArray?.economic_consultations_count}</h2>
          </div>
        </div>
        <div className="col-12 md:col-6 lg:col-4    ">
          <div className="cardHero cardHero2">
            <div className="circle">
              <RiGitRepositoryPrivateLine />
            </div>
            <h5>عدد الاستشارات الخاصة </h5>
            <h2> {EmployeesStatisticsArray?.private_consultations_count}</h2>
          </div>
        </div>
        <div className="col-12 md:col-6 lg:col-4    ">
          <div className="cardHero cardHero3">
            <div className="circle">
              <LiaFileContractSolid />
            </div>
            <h5> عدد التعاقد مع المحامين</h5>
            <h2> {EmployeesStatisticsArray?.hire_lawyers_count}</h2>
          </div>
        </div>
        {EmployeesStatisticsArray && (
          <div className="col-12 md:col-6">
            <Statistics data={EmployeesStatisticsArray?.monthly_data} />
          </div>
        )}
        {EmployeesStatisticsReportArray?.appointment_consultations_report
          ?.length > 0 && (
          <div className="col-12 md:col-6">
            <div className="card_info">
              <h3 className="title__">تقرير المواعيد والاستشارات</h3>
              <DataTable
                id="home"
                value={
                  EmployeesStatisticsReportArray?.appointment_consultations_report
                }
                className="dataTable"
                rows={5}
                paginator
                dataKey="id"
                emptyMessage="لا يوجد   بيانات متاحة"
              >
                <Column field="price" header={"السعر"} />
                <Column field="appointment_date" header={"تاريخ التعيين"} />
                <Column field="appointment_time" header={"وقت التعيين"} />
                <Column field="user.name" header={"العميل"} />
              </DataTable>
            </div>
          </div>
        )}
        {EmployeesStatisticsReportArray?.contracts_report?.length > 0 && (
          <div className="col-12 md:col-6">
            <div className="card_info">
              <h3 className="title__">تقرير العقود</h3>
              <DataTable
                id="home"
                value={EmployeesStatisticsReportArray?.contracts_report}
                paginator
                className="dataTable"
                rows={5}
                dataKey="id"
                emptyMessage="لا يوجد   بيانات متاحة"
              >
                <Column field="pages" header={"الصفح"} />
                <Column field="price" header={"السعر"} />
                <Column
                  header="ملف  الصوت"
                  body={(rowData) => (
                    <div className="StatusBtn7">
                      {rowData?.voice && (
                        <VoiceMessage voice={rowData?.voice} />
                      )}
                    </div>
                  )}
                />
                <Column
                  header="الملف"
                  body={(rowData) => (
                    <div className="StatusBtn7">
                      {rowData?.file && (
                        <a
                          href={rowData?.file}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FaFileAlt />
                        </a>
                      )}
                    </div>
                  )}
                />
                <Column field="user.name" header={"العميل"} />
              </DataTable>
            </div>
          </div>
        )}

        {EmployeesStatisticsReportArray?.hire_lawyers_report?.length > 0 && (
          <div className="col-12 md:col-6">
            <div className="card_info">
              <h3 className="title__"> تقرير توظيف المحامين</h3>
              <DataTable
                id="home"
                value={EmployeesStatisticsReportArray?.hire_lawyers_report}
                paginator
                className="dataTable"
                rows={5}
                dataKey="id"
                emptyMessage="لا يوجد   بيانات متاحة"
              >
                <Column field="price" header={"السعر"} />
                <Column field="appointment_date" header={"تاريخ التعيين"} />
                <Column field="appointment_time" header={"وقت التعيين"} />
                <Column field="user.name" header={"العميل"} />
              </DataTable>
            </div>
          </div>
        )}
        {EmployeesStatisticsReportArray?.economic_consultations_report?.length >
          0 && (
          <div className="col-12 md:col-6">
            <div className="card_info">
              <h3 className="title__"> تقرير الاستشارات الاقتصادية</h3>
              <DataTable
                id="home"
                value={
                  EmployeesStatisticsReportArray?.economic_consultations_report
                }
                paginator
                className="dataTable"
                rows={5}
                dataKey="id"
                emptyMessage="لا يوجد   بيانات متاحة"
              >
                <Column field="price" header={"السعر"} />
                <Column
                  header="ملف  الصوت"
                  body={(rowData) => (
                    <div className="StatusBtn7">
                      {rowData?.voice && (
                        <VoiceMessage voice={rowData?.voice} />
                      )}
                    </div>
                  )}
                />
                <Column
                  header="الملف"
                  body={(rowData) => (
                    <div className="StatusBtn7">
                      {rowData?.file && (
                        <a
                          href={rowData?.file}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FaFileAlt />
                        </a>
                      )}
                    </div>
                  )}
                />
                <Column field="user.name" header={"العميل"} />
              </DataTable>
            </div>
          </div>
        )}
        {EmployeesStatisticsReportArray?.private_consultations_report?.length >
          0 && (
          <div className="col-12 md:col-6">
            <div className="card_info">
              <h3 className="title__"> تقرير الاستشارات الخاصة</h3>
              <DataTable
                id="home"
                value={
                  EmployeesStatisticsReportArray?.private_consultations_report
                }
                paginator
                className="dataTable"
                rows={5}
                dataKey="id"
                emptyMessage="لا يوجد   بيانات متاحة"
              >
                <Column field="price" header={"السعر"} />
                <Column field="appointment_date" header={"تاريخ التعيين"} />
                <Column field="appointment_time" header={"وقت التعيين"} />
                <Column field="user.name" header={"العميل"} />
              </DataTable>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeStatistics;
